/* Harp & Timbrel landing page behavior (draft) */
(function(){
  if (window.__hntPb) return; window.__hntPb = true;
  var LABELS = {
    'Bible + PINK Tabs + Engraved Name': ['Pink tabs + name engraved', 'A tab on every book and the name on the cover', 1, true],
    'Bible + CREAM Tabs + Engraved Name': ['Cream tabs + name engraved', 'A tab on every book and the name on the cover', 2, false],
    'Bible w/ Name Engraving Only': ['Name engraved only', 'The name on the cover, no added tabs', 3, false],
    'Bible w/ PINK Tabs Only (no name)': ['Pink tabs, no name', 'A tab on every book and a plain cover', 4, false],
    'Bible w/ CREAM Tabs Only (no name)': ['Cream tabs, no name', 'A tab on every book and a plain cover', 5, false],
    'Engraved Bible (No Tabs)': ['Name engraved, no tabs', 'The name on the cover, no added tabs', 1, false],
    'Engraved Bible with Tabs': ['Name engraved, with tabs', 'Tabs already on and the name on the cover', 2, true]
  };
  var CFG = null;
  try { var ce = document.getElementById('hnt-pick-config'); if (ce) CFG = JSON.parse(ce.textContent); } catch (e) { CFG = null; }
  function money(c){ return '$' + (c / 100).toFixed(2); }
  function productJson(){ var el = document.querySelector('script[id^="ProductJson-"]'); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function getSelect(){ return document.querySelector('.product__variants-select select.js-variant-selector'); }
  function topOffset(){ return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hnt-top'), 10) || 0; }
  function jumpHeight(){ var j = document.querySelector('[data-hnt-jump]'); return j ? j.offsetHeight : 0; }
  function scrollToEl(el, extra){ if (!el) return; var y = el.getBoundingClientRect().top + window.pageYOffset - topOffset() - jumpHeight() - (extra || 12); window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
  function scrollToForm(){ scrollToEl(document.querySelector('.hnt-pick') || document.querySelector('.product__section-contentWrapper'), 24); }
  function sync(){ var s = getSelect(); if (!s) return; var b = document.querySelectorAll('.hnt-pick button'); for (var i = 0; i < b.length; i++) b[i].setAttribute('aria-pressed', b[i].getAttribute('data-value') === s.value ? 'true' : 'false'); }
  function choose(value){
    var s = getSelect(); if (!s) return false; var ok = false;
    for (var i = 0; i < s.options.length; i++) if (s.options[i].value === value) ok = true;
    if (!ok) return false;
    s.value = value; s.dispatchEvent(new Event('change', { bubbles: true }));
    sync(); return true;
  }
  function variantFor(p, v){ for (var k = 0; k < p.variants.length; k++) if (p.variants[k].option1 === v) return p.variants[k]; return null; }
  function makeBtn(v, title, sub, badge, variant){
    var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-value', v);
    b.innerHTML = '<span><span class="hnt-pick__t"></span>' + (badge ? '<span class="hnt-pick__pop"></span>' : '') + (sub ? '<span class="hnt-pick__s"></span>' : '') + '</span><span class="hnt-pick__p"></span>';
    b.querySelector('.hnt-pick__t').textContent = title;
    if (badge) b.querySelector('.hnt-pick__pop').textContent = badge;
    if (sub) b.querySelector('.hnt-pick__s').textContent = sub;
    b.querySelector('.hnt-pick__p').textContent = variant ? money(variant.price) : '';
    if (variant && variant.available === false) { b.disabled = true; b.querySelector('.hnt-pick__p').textContent = 'Sold out'; }
    b.addEventListener('click', function(){ choose(v); });
    return b;
  }
  function addLabel(wrap, text, extra){ var l = document.createElement('div'); l.className = 'hnt-pick__label' + (extra ? ' ' + extra : ''); l.textContent = text; wrap.appendChild(l); }
  function buildPicker(){
    var s = getSelect(), p = productJson();
    if (!s || !p || s.getAttribute('data-hnt-done')) return;
    var holder = s.closest('.product-form__input'); if (!holder) return;
    var values = []; for (var i = 0; i < s.options.length; i++) values.push(s.options[i].value);
    var wrap = document.createElement('div'); wrap.className = 'hnt-pick'; wrap.setAttribute('role', 'group');
    if (CFG && CFG.mode === 'set') {
      wrap.setAttribute('aria-label', CFG.label || 'Choose an option');
      addLabel(wrap, CFG.label || 'Choose an option');
      var fv = CFG.featured, fvar = variantFor(p, fv);
      if (fvar) {
        var sub = CFG.featured_sub || '';
        if (CFG.count > 1) sub += (sub ? '. ' : '') + 'About ' + money(Math.round(fvar.price / CFG.count)) + ' an ornament';
        var fb = makeBtn(fv, CFG.featured_title || fv, sub, CFG.badge, fvar); fb.className = 'hnt-pick__feat'; wrap.appendChild(fb);
      }
      var rest = values.filter(function(v){ return v !== fv; });
      if (rest.length) {
        addLabel(wrap, CFG.chips_label || 'Or choose one', 'hnt-pick__label--sub');
        var grid = document.createElement('div'); grid.className = 'hnt-pick__chips';
        rest.forEach(function(v){ grid.appendChild(makeBtn(v, v, '', '', variantFor(p, v))); });
        wrap.appendChild(grid);
      }
    } else {
      values.sort(function(a, b){ return (LABELS[a] ? LABELS[a][2] : 99) - (LABELS[b] ? LABELS[b][2] : 99); });
      var lbl = (CFG && CFG.label) || 'Choose your Bible';
      wrap.setAttribute('aria-label', lbl); addLabel(wrap, lbl);
      values.forEach(function(v){ var L = LABELS[v] || [v, '', 99, false]; wrap.appendChild(makeBtn(v, L[0], L[1], L[3] ? 'Most popular' : '', variantFor(p, v))); });
    }
    holder.style.display = 'none'; holder.parentNode.insertBefore(wrap, holder);
    s.setAttribute('data-hnt-done', '1'); s.addEventListener('change', sync); sync();
  }
  function stickyTop(){
    var h = 0, els = document.querySelectorAll('.navigation--sticky, #shopify-section-header, #shopify-section-announcement-bar, .header-section, header');
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.1) {
        var r = els[i].getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0 && r.height < 200 && r.bottom > h) h = r.bottom;
      }
    }
    document.documentElement.style.setProperty('--hnt-top', Math.round(h) + 'px');
  }
  function initJump(){
    var nav = document.querySelector('[data-hnt-jump]'); if (!nav) return;
    var links = nav.querySelectorAll('a[href^="#"]'), targets = [];
    for (var i = 0; i < links.length; i++) { var id = links[i].getAttribute('href').slice(1); var t = id ? document.getElementById(id) : null; if (t) targets.push({ link: links[i], el: t }); else if (id) links[i].style.display = 'none'; }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        targets.forEach(function(t){
          var on = t.el === e.target; t.link.classList.toggle('is-active', on);
          if (on && window.innerWidth < 900) t.link.parentNode.scrollTo({ left: t.link.offsetLeft - 20, behavior: 'smooth' });
        });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    targets.forEach(function(t){ io.observe(t.el); });
  }
  function initReviews(){
    var grids = document.querySelectorAll('[data-hnt-revs]');
    for (var g = 0; g < grids.length; g++) (function(grid){
      var limit = parseInt(grid.getAttribute('data-limit'), 10) || 0, sec = grid.closest('section'), more = sec ? sec.querySelector('[data-hnt-more]') : null;
      if (grid.classList.contains('hnt-revgrid') && limit && window.innerWidth < 740) {
        var items = grid.querySelectorAll('.hnt-rev');
        if (items.length > limit) {
          for (var i = limit; i < items.length; i++) items[i].classList.add('is-hidden');
          if (more) { more.hidden = false; more.addEventListener('click', function(){ var h = grid.querySelectorAll('.hnt-rev.is-hidden'); for (var j = 0; j < h.length; j++) h[j].classList.remove('is-hidden'); more.hidden = true; }); }
        }
      }
      if (grid.classList.contains('hnt-revrow') && sec) {
        var step = function(d){ grid.scrollBy({ left: d * grid.clientWidth * 0.85, behavior: 'smooth' }); };
        var pv = sec.querySelector('[data-hnt-prev]'), nx = sec.querySelector('[data-hnt-next]');
        if (pv) pv.addEventListener('click', function(){ step(-1); });
        if (nx) nx.addEventListener('click', function(){ step(1); });
      }
    })(grids[g]);
  }
  function initClicks(){
    document.addEventListener('click', function(ev){
      var a = ev.target.closest ? ev.target.closest('a, button') : null; if (!a) return;
      if (a.hasAttribute('data-hnt-choose')) {
        ev.preventDefault(); var picked = choose(a.getAttribute('data-hnt-choose')); scrollToForm();
        var pick = document.querySelector('.hnt-pick'); if (picked && pick) { pick.classList.remove('is-flash'); void pick.offsetWidth; pick.classList.add('is-flash'); }
        return;
      }
      if (a.hasAttribute('data-hnt-buy')) { ev.preventDefault(); scrollToForm(); return; }
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1 && (a.closest('[data-hnt-jump]') || a.hasAttribute('data-hnt-anchor'))) { var t = document.getElementById(href.slice(1)); if (t) { ev.preventDefault(); scrollToEl(t, 0); } }
    });
  }
  function init(){
    stickyTop(); buildPicker(); initJump(); initReviews(); initClicks();
    setTimeout(buildPicker, 800); setTimeout(stickyTop, 800);
    var ticking = false;
    window.addEventListener('scroll', function(){ if (ticking) return; ticking = true; requestAnimationFrame(function(){ stickyTop(); ticking = false; }); }, { passive: true });
    window.addEventListener('resize', stickyTop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();